import React from 'react';
import {
	Card,
	Col,
	Flex,
	Row,
	Table,
	Tag,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faCheckCircle,
	faClock,
} from '@fortawesome/pro-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { CargoContractStatusTypes } from '@shared/utils/constants';
import { CargoDetails } from '@api/features/cargos/getCargoDetails';
import { Port } from '@api/utils/ports';
import Button from '../../Button';
import legendStyles from '../MapLegend.module.css';
import cargoMapStyles from './CargoMapLegend.module.css';
import getCargoMapColumns from './getCargoMapColumns';

type CargoMapPanelProps = {
	selectedLoadingPort: Port;
	selectedPortCargos: CargoDetails[];
	onClose: () => void;
};

const CargoMapPanel = ({
	selectedLoadingPort,
	selectedPortCargos,
	onClose,
}: CargoMapPanelProps) => {
	const history = useHistory();
	const cargoColumns = getCargoMapColumns({ history });

	const contractedCount = selectedPortCargos.filter((c) => (
		c.contractStatus === CargoContractStatusTypes.Contracted
	)).length;

	const tentativeCount = selectedPortCargos.filter((c) => (
		c.contractStatus === CargoContractStatusTypes.TentativeBooking
	)).length;

	const hasContracted = contractedCount > 0;

	return (
		<div className={cargoMapStyles.cargoMap}>
			<Card
				size="small"
				styles={{
					body: {
						padding: '9px 12px 0',
					},
				}}
				className={cargoMapStyles.cargoMapCard}
			>
				<Row
					justify="space-between"
					align="middle"
					className={cargoMapStyles.headerRow}
				>
					<Col>
						<Flex align="center" gap={10}>
							<FontAwesomeIcon
								className={hasContracted ?
									legendStyles.contractedCargosIcon :
									legendStyles.tentativeBookingIcon
								}
								size="lg"
								icon={hasContracted ? faCheckCircle : faClock}
							/>
							<b className={cargoMapStyles.portTitle}>
								{selectedLoadingPort.name}
							</b>
							{contractedCount > 0 && (
								<Tag color="purple" className={cargoMapStyles.statusTag}>
									{contractedCount} Contracted
								</Tag>
							)}
							{tentativeCount > 0 && (
								<Tag color="gold" className={cargoMapStyles.statusTag}>
									{tentativeCount} Tentative
								</Tag>
							)}
						</Flex>
					</Col>
					<Col>
						<Button
							type="text"
							size="small"
							icon={<CloseOutlined />}
							onClick={onClose}
							className={cargoMapStyles.closeButton}
						/>
					</Col>
				</Row>
				<Row gutter={[16, 8]}>
					<Table
						size="small"
						bordered={false}
						rowKey="id"
						columns={cargoColumns}
						dataSource={selectedPortCargos}
						pagination={false}
						scroll={{ x: 1200 }}
					/>
				</Row>
			</Card>
		</div>
	);
};

export default CargoMapPanel;